export const HDYHAU_OPTIONS = [
  {value: 'referred', label: 'Referred by a Campus student'},
  {value: 'instagram', label: 'Instagram'},
  {value: 'tiktok', label: 'TikTok'},
  {value: 'snapchat', label: 'Snapchat'},
  {value: 'linkedin', label: 'LinkedIn'},
  {value: 'facebook', label: 'Facebook'},
  {value: 'podcast', label: 'Podcast'},
  {value: 'myEmployer', label: 'My employer'},
  {value: 'wordOfMouth', label: 'Word of mouth / Someone told me'},
  {value: 'youtube', label: 'YouTube'},
  {value: 'tvStreaming', label: 'TV/Streaming'},
  {value: 'internetSearch', label: 'Internet search, Search engine'},
  {value: 'aiSearch', label: 'AI Search (ChatGPT, Claude, Gemini, etc.)'},
  {value: 'other', label: 'Other'},
]

export const HDYHAU_FOLLOW_UPS = {
  instagram: {
    question: 'Can you share where on Instagram?',
    type: 'radio',
    options: [
      {value: 'brandPage', label: "Our brand's Instagram page"},
      {value: 'ad', label: 'Instagram ad'},
      {
        value: 'influencer',
        label: 'Influencer',
        nestedText: {placeholder: 'Name/handle (optional)'},
      },
    ],
  },
  tiktok: {
    question: 'Can you share where on TikTok?',
    type: 'radio',
    options: [
      {value: 'brandPage', label: "Our brand's TikTok page"},
      {value: 'ad', label: 'TikTok ad'},
      {
        value: 'influencer',
        label: 'Influencer',
        nestedText: {placeholder: 'Name/handle (optional)'},
      },
    ],
  },
  snapchat: {
    question: 'Can you share where on Snapchat?',
    type: 'radio',
    options: [
      {value: 'brandPage', label: "Our brand's Snapchat"},
      {value: 'ad', label: 'Snapchat ad'},
    ],
  },
  linkedin: {
    question: 'Where on LinkedIn?',
    type: 'radio',
    options: [
      {value: 'ad', label: 'LinkedIn ad'},
      {value: 'postOrContent', label: 'LinkedIn post or content'},
      {
        value: 'other',
        label: 'Other',
        nestedText: {placeholder: 'Please specify (optional)'},
      },
    ],
  },
  facebook: {
    question: 'Can you share where on Facebook?',
    type: 'radio',
    options: [
      {value: 'brandPage', label: "Our brand's Facebook page"},
      {value: 'ad', label: 'Facebook ad'},
      {
        value: 'influencer',
        label: 'Influencer',
        nestedText: {placeholder: 'Name/handle (optional)'},
      },
    ],
  },
  podcast: {
    question: 'Can you share which podcast?',
    type: 'text',
    placeholder: 'Podcast name (optional)',
  },
  myEmployer: {
    question: 'Select employer',
    type: 'radio',
    options: [
      {value: 'workWhile', label: 'WorkWhile'},
      {
        value: 'other',
        label: 'Other',
        nestedText: {placeholder: 'Employer name (optional)'},
      },
    ],
  },
  wordOfMouth: {
    question: 'Who told you?',
    type: 'radio',
    options: [
      {value: 'familyMember', label: 'Family member'},
      {value: 'friend', label: 'Friend'},
      {value: 'coworker', label: 'Co-worker or colleague'},
      {value: 'campusStudent', label: 'Campus student'},
      {value: 'campusStaff', label: 'Campus staff or faculty'},
      {value: 'schoolCounselor', label: 'School counselor or teacher'},
      {
        value: 'other',
        label: 'Other',
        nestedText: {placeholder: 'Please specify (optional)'},
      },
    ],
  },
  youtube: {
    question: 'Can you share where on YouTube?',
    type: 'radio',
    options: [
      {value: 'brandAccount', label: "Our brand's YouTube account"},
      {value: 'ad', label: 'YouTube ad'},
      {
        value: 'youtuber',
        label: 'YouTuber',
        nestedText: {placeholder: 'Name/channel (optional)'},
      },
    ],
  },
  tvStreaming: {
    question: 'Which network / streaming platform were you watching?',
    type: 'text',
    placeholder: 'Network or platform (optional)',
  },
  internetSearch: {
    question: 'Can you tell us which search engine?',
    type: 'radio',
    options: [
      {value: 'google', label: 'Google'},
      {value: 'bing', label: 'Bing'},
      {value: 'yahoo', label: 'Yahoo'},
      {
        value: 'other',
        label: 'Other',
        nestedText: {placeholder: 'Search engine name (optional)'},
      },
    ],
  },
  aiSearch: {
    question: 'Can you tell us which platform?',
    type: 'radio',
    options: [
      {value: 'chatgpt', label: 'ChatGPT'},
      {value: 'googleGemini', label: 'Google Gemini'},
      {value: 'microsoftCopilot', label: 'Microsoft Copilot'},
      {value: 'perplexity', label: 'Perplexity'},
      {value: 'claude', label: 'Claude'},
      {
        value: 'other',
        label: 'Other',
        nestedText: {placeholder: 'Platform name (optional)'},
      },
    ],
  },
  other: {
    question: 'Please share where you heard about us',
    type: 'text',
    field: 'otherDescription',
    placeholder: 'Please describe (optional)',
  },
}

export function getHdyhauFollowUp(parentValue) {
  return HDYHAU_FOLLOW_UPS[parentValue] ?? null
}

// Resumed applications can hold answers from an older option set (e.g.
// 'reddit', removed in STX-473). The select has no matching <option> for
// them, so the browser silently displays the first option while the stale
// value is what gets submitted. Clear anything the current config can't
// represent before hydrating Formik.
export function sanitizeHdyhauSnapshot(form) {
  if (!form || typeof form !== 'object') {
    return form
  }
  const parent = form.hearAboutCampus
  if (!parent) {
    return form
  }
  let sanitized = form
  if (!HDYHAU_OPTIONS.some(option => option.value === parent)) {
    sanitized = {
      ...sanitized,
      hearAboutCampus: '',
      hearAboutCampusFollowUp: '',
      hearAboutCampusFollowUpDetail: '',
      otherDescription: '',
    }
  } else {
    const followUpValue = sanitized.hearAboutCampusFollowUp
    const followUp = getHdyhauFollowUp(parent)
    if (
      followUpValue &&
      !followUp?.options?.some(option => option.value === followUpValue)
    ) {
      sanitized = {
        ...sanitized,
        hearAboutCampusFollowUp: '',
        hearAboutCampusFollowUpDetail: '',
      }
    }
  }
  // A referral code only makes sense alongside a student-referral answer.
  // The clearing above can invalidate one, and older snapshots can carry a
  // code from an answer the applicant later changed - either way the whole
  // values object is submitted, so a stale code would reach the backend.
  if (sanitized.referredBy && sanitized.hearAboutCampus !== 'referred') {
    sanitized = {...sanitized, referredBy: ''}
  }
  return sanitized
}

export function getNestedTextOption(followUp, followUpValue) {
  if (!followUp?.options || !followUpValue) return null
  return followUp.options.find(o => o.value === followUpValue && o.nestedText)
}
